import { ListFilter } from "lucide-react";
import { useDropdownVisibility } from '../../../hooks/useDropdownVisibility';
import "../MatchFilter.css";

export default function DayFilter({ setClubFilter, setDayFilter, setDisplayMatches, allMatches, matchDays }) {
  const { refs, toggleDropdown, visibilityState } = useDropdownVisibility(['day']);

  const filterByDay = (day) => {
    const filteredMatches = allMatches.filter((match) => match.gameday === day);
    setDisplayMatches(filteredMatches);
    setDayFilter(day);
    setClubFilter(null);
  };

  return (
    <div
      className="spiele-page__filter spiele-page__filter-day"
      ref={refs.day}
    >
      <button
        onClick={() => toggleDropdown('day')}
      >
        <h3>
          <ListFilter /> SPIELTAGE
        </h3>
      </button>
      {visibilityState.day && (
        <div className="dropdown-menu">
          <ul>
            <li>
              <button
                onClick={() => {
                  setClubFilter(null);
                  setDayFilter(null);
                  setDisplayMatches(allMatches);
                  toggleDropdown('day');
                }}
              >
                Alle Spieltage
              </button>
            </li>
            {matchDays.map((day) => (
              <li key={day}>
                <button
                  onClick={() => {
                    filterByDay(day);
                    toggleDropdown('day');
                  }}
                >
                  {day}. Spieltag
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
